// extracted by mini-css-extract-plugin
export default {"cart_block":"CartWithItems_cart_block__k7y0I","sub_product":"CartWithItems_sub_product__42G7m","sublevel_svg":"CartWithItems_sublevel_svg__f1Lkn"};